import styled from 'styled-components';

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  text-align: center;
  padding: 40px 20px;
  background: ${(p) => p.theme.white};
  border-radius: 12px;
  margin: 0 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: 1px solid #e2e8f0;
`;

export const LoadingSpinner = styled.div`
  border: 4px solid #e2e8f0;
  border-top: 4px solid #0600B4;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
  margin-bottom: 30px;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

export const LoadingText = styled.h2`
  color: #0600B4;
  font-size: 24px;
  font-weight: 600;
  margin: 0 0 15px 0;
  font-family: "Figtree", ui-sans-serif, system-ui, -apple-system, "system-ui", "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif;
`;

export const LoadingSubtext = styled.p`
  color: #6b7280;
  font-size: 16px;
  margin: 0;
  line-height: 1.5;
  font-family: "Figtree", ui-sans-serif, system-ui, -apple-system, "system-ui", "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif;
`;

export const PageHeader = styled.div`
  text-align: center;
  margin-bottom: 40px;
  padding: 0 20px;
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    bottom: -20px;
    left: 50%;
    transform: translateX(-50%);
    width: 60px;
    height: 3px;
    background: #0600B4;
    border-radius: 2px;
  }
`;

export const PageTitle = styled.h1`
  color: #0600B4;
  font-size: 32px;
  font-weight: 700;
  margin: 0 0 15px 0;
  font-family: "Figtree", ui-sans-serif, system-ui, -apple-system, "system-ui", "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif;
`;

export const PageSubtitle = styled.p`
  color: #6b7280;
  font-size: 18px;
  margin: 0;
  line-height: 1.5;
  max-width: 600px;
  margin: 0 auto;
  font-family: "Figtree", ui-sans-serif, system-ui, -apple-system, "system-ui", "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif;
`;

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  text-align: center;
  padding: 40px 20px;
  background: linear-gradient(135deg, ${(p) => p.theme.very_light_red || '#fff5f5'} 0%, ${(p) => p.theme.white} 100%);
  border-radius: 12px;
  margin: 0 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: 1px solid ${(p) => p.theme.light_red || '#fed7d7'};
`;

export const ErrorTitle = styled.h2`
  color: ${(p) => p.theme.dark_red || '#c53030'};
  font-size: 24px;
  font-weight: 600;
  margin: 0 0 15px 0;
  font-family: ${(p) => p.theme.fontFamily};
`;

export const ErrorMessage = styled.p`
  color: ${(p) => p.theme.dark_gray};
  font-size: 16px;
  margin: 0 0 30px 0;
  line-height: 1.5;
  max-width: 500px;
`;

export const ErrorActions = styled.div`
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
  justify-content: center;
`;

export const RetryButton = styled.button`
  background: ${(p) => p.theme.blue};
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: ${(p) => p.theme.fontFamily};

  &:hover:not(:disabled) {
    background: ${(p) => p.theme.dark_blue};
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  &:disabled {
    background: ${(p) => p.theme.light_gray};
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
`;

export const LoginButton = styled.button`
  background: transparent;
  color: ${(p) => p.theme.blue};
  border: 2px solid ${(p) => p.theme.blue};
  padding: 12px 24px;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: ${(p) => p.theme.fontFamily};

  &:hover {
    background: ${(p) => p.theme.blue};
    color: white;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
`;

export const EmailForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const EmailLabel = styled.label`
  color: #374151;
  font-size: 14px;
  font-weight: 500;
  margin: 0;
  font-family: ${(p) => p.theme.fontFamily || 'system-ui, -apple-system, sans-serif'};
  display: block;
  text-align: left;
  width: 100%;
`;

export const EmailInput = styled.input`
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 16px;
  font-family: ${(p) => p.theme.fontFamily || 'system-ui, -apple-system, sans-serif'};
  transition: border-color 0.2s ease;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #1a365d;
    box-shadow: 0 0 0 3px rgba(26, 54, 93, 0.1);
  }

  &:disabled {
    background-color: #f3f4f6;
    cursor: not-allowed;
  }

  &::placeholder {
    color: #9ca3af;
  }
`;

export const SubmitButton = styled.button`
  background: #0600B4;
  color: white;
  border: none;
  padding: 14px 24px;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: ${(p) => p.theme.fontFamily || 'system-ui, -apple-system, sans-serif'};
  width: 100%;
  margin-top: 8px;

  &:hover:not(:disabled) {
    background: #0500a0;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(6, 0, 180, 0.3);
  }

  &:disabled {
    background: #9ca3af;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
`;

// New styles for the image design
export const CenteredContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  min-height: auto;
  padding: 20px;
  padding-top: 40px;
  background-color: ${(p) => p.theme.white};
`;

export const MacmillanLogo = styled.div`
  margin-bottom: 1rem;
`;

export const MacmillanBrand = styled.h1`
  color: #1a365d;
  font-size: 28px;
  font-weight: 700;
  margin: 0;
  font-family: ${(p) => p.theme.fontFamily || 'system-ui, -apple-system, sans-serif'};
  
  span {
    font-weight: 600;
  }
`;

export const FormCard = styled.div`
  background: white;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  box-shadow: ${(p) => p.theme.boxShadow};
  width: 542px;
  margin-top: 1rem;
  padding: 0 22px;
  overflow: hidden;
`;

export const TabContainer = styled.div`
  display: flex;
  border-bottom: 1px solid #e2e8f0;
`;

export const Tab = styled.button`
  flex: 1;
  background: none;
  border: none;
  padding: 16px 20px;
  font-size: 16px;
  font-weight: 500;
  color: #64748b;
  cursor: pointer;
  transition: color 0.2s ease;
  font-family: ${(p) => p.theme.fontFamily || 'system-ui, -apple-system, sans-serif'};

  &:hover {
    color: #1a365d;
  }
`;

export const ActiveTab = styled.div`
  flex: 1;
  padding: 16px 20px;
  font-size: 16px;
  font-weight: 500;
  color: #0600B4;
  border-bottom: 3px solid #0600B4;
  font-family: ${(p) => p.theme.fontFamily || 'system-ui, -apple-system, sans-serif'};
`;

export const TabSeparator = styled.div`
  display: none;
`;

export const FormContent = styled.div`
  padding: 32px;
`;
